window.addEventListener('DOMContentLoaded', () => {
  /**
   * Function to handle the click on the copy link button
   */
  async function handleLinkCopiedClick(event) {
    event.preventDefault();
    const copyLinkElement = event.target.closest('.copy-link');
    const linkUrl = copyLinkElement.getAttribute('aria-link');
    try {
      // Request permission to write to the clipboard
      const permissionStatus = await navigator.permissions.query({ name: 'clipboard-write' });

      if (permissionStatus.state === 'granted' || permissionStatus.state === 'prompt') {
        // Write the link URL to the clipboard
        await navigator.clipboard.writeText(linkUrl);
        const linkCopied = copyLinkElement.querySelector('.link-copied');

        linkCopied.classList.add('copied');

        setTimeout(() => {
          linkCopied.classList.remove('copied');
        }, 1500);
      }
    } catch (error) {
      /* eslint-disable no-console */
      console.error(error);
    }
  }

  document.querySelectorAll('.copy-link').forEach((element) => {
    element.addEventListener('click', handleLinkCopiedClick);
  });
});
